<script setup lang="ts">
/**
 * SplitNoteIcon – eigenes Inline-SVG für die „Note teilen"-Aktion.
 *
 * Zeigt zwei Notenköpfe, zwischen denen eine kräftige gestrichelte Linie den „Schnitt" andeutet (aus
 * einer Note werden zwei gleich lange) – aussagekräftiger als das frühere `fa6-solid:divide` (÷).
 * Bewusst bold & minimal für Lesbarkeit auf den ~14 px großen Toolbar-Buttons; die mittige Trennlinie
 * grenzt es klar vom {@link TieIcon} (verbindender Bogen oben) ab.
 *
 * Single-Root-`<svg>` mit `width/height=1em` und `currentColor` (erbt Button-Textfarbe UND
 * `disabled:opacity-30`); `class` fällt automatisch durch.
 */
</script>

<template>
  <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      fill="currentColor"
      aria-hidden="true"
  >
    <circle cx="7" cy="15" r="3.4"/>
    <circle cx="17" cy="15" r="3.4"/>
    <path
        d="M12 3 V21"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-dasharray="3 2.4"
        stroke-linecap="round"
    />
  </svg>
</template>
